import { cn } from '../../utils/cn';

/** `.pen` `ds/chip/choice--default` / `--selected`. */
export function QuickCreateChoiceChip({
  label,
  selected,
  onSelect,
  dotClassName,
  icon: Icon,
  ariaLabel,
  ariaHaspopup,
}) {
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-pressed={selected}
      aria-label={ariaLabel || label}
      aria-haspopup={ariaHaspopup}
      className={cn(
        'flex items-center gap-space-2 rounded-ds-full border px-space-4 py-space-2 type-body-sm transition-colors',
        selected
          ? 'border-2 border-sage-500 bg-sage-tint text-sage-on-tint'
          : 'border-border bg-muted text-muted-foreground hover:bg-stone-200 dark:hover:bg-stone-700',
      )}
    >
      {dotClassName ? (
        <span className={cn('h-2 w-2 shrink-0 rounded-full', dotClassName)} aria-hidden />
      ) : null}
      {Icon ? <Icon size={15} className="shrink-0" aria-hidden /> : null}
      {label}
    </button>
  );
}
